import moment from "moment";

export const formatDateMMDDYYYY = (date) => {
  if (!date) return "";
  return moment(date).format("MM-DD-YYYY");
};

export const setFormatDate = (date) => {
  if (!date || date === "") return null;

  const cleanedDate =
    date.replace(/T/g, " ").replace(/Z|z/g, "").split(".")[0] || "";
  return formatDateMMDDYYYY(moment.utc(cleanedDate).toISOString());
};
export const dateTimeFormat = (date) => {
  if (!date || date === "") return null;

  const parsed = moment.utc(date);
  if (!parsed.isValid()) {
    return null;
  }

  // QA finding (2026-09-15, Renewal & Transaction History): the date was right but the clock
  // time was the raw UTC hour, never converted - moment.utc() keeps the moment IN UTC for
  // display, it doesn't shift it. Same class of bug already fixed server-side for referral
  // rewards' earnedAt (2026-09-09) - this admin panel consistently shows IST (UTC+5:30), so this
  // shared formatter (used across every date/time column, not just this one page) needs the
  // same +5:30 applied. utcOffset(330) is a fixed IST shift, independent of the viewer's own
  // browser timezone - every admin sees the same wall-clock time regardless of where they are.
  return parsed.utcOffset(330).format("DD-MM-YYYY hh:mm:ss A");
};
